export * from '@primeuix/themes/nora/splitbutton';
export { default } from '@primeuix/themes/nora/splitbutton';
